if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
 
        this.form = this.querySelector('form');
        this.variantIdInput = this.querySelector('[name=id]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
 
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.form.querySelector('[name=id]')?.addEventListener('change', this.onVariantChange.bind(this));
        }
      }
 
      onVariantChange() {
        this.handleErrorMessage();
      }
 
      onSubmitHandler(evt) {
        evt.preventDefault();
 
        // 🔒 VALIDATION HYDROGEL
        const phoneInput = this.form.querySelector('#phone_model');
        if (phoneInput && phoneInput.value.trim() === '') {
          phoneInput.style.border = '2px solid red';
          phoneInput.focus();
          return;
        }
        if (phoneInput) {
          phoneInput.style.border = '';
        }
 
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
 
        this.handleErrorMessage();
        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
 
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
 
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
 
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.submitButton?.classList.remove('loading');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
              this.submitButton?.removeAttribute('aria-disabled');
              return;
            }
 
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
 
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton?.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            if (this.cart && this.submitButton)
              this.submitButton.removeAttribute('aria-disabled');
          });
      }
 
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
 
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
 
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
 
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
 
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText && (this.submitButtonText.textContent = text);
        } else {
          this.submitButton?.removeAttribute('disabled');
          if (this.submitButtonText && window.variantStrings?.addToCart)
            this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
 
      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }
 
      get hideErrors() {
        return this.dataset.hideErrors === 'true';
      }
    }
  );
}